"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readingAfterOrEqual = exports.formatFullDateNoYear = exports.formatFullDate = exports.dateToString = exports.isValidDate = exports.isValidAddressLine = void 0;
var date_fns_1 = require("date-fns");
var isValidAddressLine = function (addressLine, text) {
    if (addressLine === 'line1') {
        return /^\S+(\s+\S+)*$/i.test(text);
    }
    if (addressLine === 'town') {
        return /^\S+(\s+\S+)*$/i.test(text);
    }
    if (addressLine === 'postcode') {
        return /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})/gm.test(text);
    }
};
exports.isValidAddressLine = isValidAddressLine;
function isValidDate(date) {
    var d = new Date(date);
    var _a = __read(date.split('-'), 3), year = _a[0], month = _a[1], day = _a[2];
    if (d.getFullYear() === Number(year) &&
        d.getMonth() === Number(month) - 1 &&
        d.getDate() === Number(day)) {
        return true;
    }
    return false;
}
exports.isValidDate = isValidDate;
function dateToString(date) {
    if (date.year === '' || date.month === '' || date.day === '') {
        return '';
    }
    return "".concat(date.year, "-").concat(date.month, "-").concat(date.day);
}
exports.dateToString = dateToString;
var formatFullDate = function (date) {
    return (0, date_fns_1.format)(date, 'd MMM yyyy');
};
exports.formatFullDate = formatFullDate;
var formatFullDateNoYear = function (date) {
    return (0, date_fns_1.format)(date, 'd MMMM');
};
exports.formatFullDateNoYear = formatFullDateNoYear;
var readingAfterOrEqual = function (readingDateTime, date) {
    return (0, date_fns_1.isAfter)(readingDateTime, date) || (0, date_fns_1.isEqual)(readingDateTime, date);
};
exports.readingAfterOrEqual = readingAfterOrEqual;
